import { error } from "@workspace/common/src/assets/images";
import {
  FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID,
  FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_SUCCESS,
  FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_FAILURE,
} from "./actionTypes";

const initialState = {
  tos: {},
  error: false,
  loading: false,
  errorMsg: "",
};

const TosReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID:
      return {
        ...state,
      };
    case FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_SUCCESS:
      return {
        ...state,
        tos: action.payload,
      };
    case FETCH_TOS_BY_JOB_ID_AND_CANDIDATE_ID_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default TosReducer;
